const PINCODE_REGEX = /^\d{5}$/;

// Mirrors the backend's KioskPinRules exactly: these 12 full-length runs are the only "sequential"
// values — wrap-around (e.g. "90123", "09876") is deliberately NOT in this list.
const SEQUENTIAL_RUNS = [
  '01234',
  '12345',
  '23456',
  '34567',
  '45678',
  '56789',
  '98765',
  '87654',
  '76543',
  '65432',
  '54321',
  '43210',
];

const isAllSameDigit = (pin: string): boolean => pin.split('').every(digit => digit === pin[0]);

const isRepeatingPair = (pin: string): boolean => pin[0] === pin[2] && pin[2] === pin[4] && pin[1] === pin[3];

/** Client-side mirror of the backend's format + strength rules. The server stays authoritative. */
export const isPincodeValid = (pin: string): boolean =>
  PINCODE_REGEX.test(pin) && !SEQUENTIAL_RUNS.includes(pin) && !isAllSameDigit(pin) && !isRepeatingPair(pin);
